import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.number.constructor.js";
import { computed, defineComponent, ref } from "vue"; // modules

import AuthModule from "@/store/modules/auth"; // components

import { Navbar, AppMain, Footer } from "./components";
import SalesClosedBanner from "@/views/Booking/components/SalesClosedBanner.vue";
import RefreshApp from "../Booking/components/RefreshApp.vue";
import { Modal } from "@/components/index";
import BookingModule from "@/store/modules/booking";
import UserModule from "@/store/modules/user";
import { isUserLoggedIn } from "@/utils/vue-helpers/user";
import { hasSalesStarted } from "@/utils/vue-helpers/cash-float";
import AppModule from "@/store/modules/app";
import Teams from "../Booking/components/Teams.vue";
import { BookingStep } from "@/constants/booking";
import CashFloatModule from "@/store/modules/cash-float";
import DeviceModule from "@/store/modules/device";
import RestoreLogs from "../Booking/components/RestoreLogs.vue";
import { openLink } from "@/utils/helpers/common";
import copyIcon from "@/assets/images/svg/copy.svg";
import checkIcon from "@/assets/images/svg/white-check.svg";
import closeIcon from "@/assets/images/svg/close.svg";
import { useI18n } from "vue-i18n";
import POSConfigModule from "@/store/modules/pos-config";
import ComplianceModule from "@/store/modules/compliance";
import SellingDisabled from "../Booking/components/SellingDisabled.vue";
export default defineComponent({
  name: "Layout",
  components: {
    Modal: Modal,
    Navbar: Navbar,
    AppMain: AppMain,
    Footer: Footer,
    SalesClosedBanner: SalesClosedBanner,
    RefreshApp: RefreshApp,
    Teams: Teams,
    RestoreLogs: RestoreLogs,
    SellingDisabled: SellingDisabled
  },
  setup: function setup() {
    var _useI18n = useI18n({}),
        t = _useI18n.t;

    var isAuth = computed(function () {
      return AuthModule.getIsAuth;
    });
    var isLoading = computed(function () {
      return AppModule.isLoading;
    });
    var isRefreshing = computed(function () {
      return AppModule.isRefreshing;
    });
    var isRestoringLogs = computed(function () {
      return AppModule.isRestoringLogs;
    });
    var hasUser = computed(function () {
      return UserModule.hasUser;
    });
    var showTeamsView = computed(function () {
      return isAuth.value && BookingModule.bookingStep === BookingStep.Teams;
    });
    var showCashfloatOpen = computed(function () {
      return !DeviceModule.isOldDeviceLogic && CashFloatModule.isOpeningCashfloat;
    });
    var showCashfloatClose = computed(function () {
      return !DeviceModule.isOldDeviceLogic && CashFloatModule.isClosingCashfloat;
    });
    var canSellInBelgium = computed(function () {
      if (POSConfigModule.getGroupCountryCode !== "BE") {
        // no check required outside Belgium
        return true;
      } // package should be initialized and fdm should be connected


      return ComplianceModule.complianceStatus.packageInit && ComplianceModule.complianceStatus.fdmConnection;
    });
    var canSellInSpain = computed(function () {
      if (POSConfigModule.getGroupCountryCode !== "ES") {
        // no check required outside Spain
        return true;
      } // package should be initialized and fdm should be connected


      return ComplianceModule.complianceStatus.packageInit && ComplianceModule.complianceStatus.efrConnection;
    });
    var isAllowedToBypassCompliance = computed(function () {
      // colleagues are allowed to bypass Belgium compliance checks
      return UserModule.isColleague;
    });
    var showCopyCheck = ref(false);

    function copyToClipboard(text) {
      navigator.clipboard.writeText(text).then(function () {
        showCopyCheck.value = true;
        setTimeout(function () {
          showCopyCheck.value = false;
        }, 1500);
      });
    }

    var closingSummaryDocLink = "https://knowledge.smeetz.com/en/articles/11424684-beta-new-pos-closure-and-receipt";
    var showReleaseBanner = computed(function () {
      return !AppModule.dismissedReleaseBannerForUserIds.includes(UserModule.user.id);
    });

    function closeReleaseBanner() {
      AppModule.addDismissedReleaseBannerForUserId(Number(UserModule.userId));
    }

    return {
      hasSalesStarted: hasSalesStarted,
      isUserLoggedIn: isUserLoggedIn,
      isAuth: isAuth,
      isLoading: isLoading,
      hasUser: hasUser,
      isRefreshing: isRefreshing,
      isRestoringLogs: isRestoringLogs,
      showTeamsView: showTeamsView,
      showCashfloatOpen: showCashfloatOpen,
      showCashfloatClose: showCashfloatClose,
      canSellInBelgium: canSellInBelgium,
      canSellInSpain: canSellInSpain,
      isAllowedToBypassCompliance: isAllowedToBypassCompliance,
      openLink: openLink,
      showCopyCheck: showCopyCheck,
      copyToClipboard: copyToClipboard,
      copyIcon: copyIcon,
      checkIcon: checkIcon,
      closingSummaryDocLink: closingSummaryDocLink,
      closeIcon: closeIcon,
      showReleaseBanner: showReleaseBanner,
      closeReleaseBanner: closeReleaseBanner,
      t: t
    };
  }
});